:host {
    position: relative;
    display: inline-block;
}

.floating {
    position: fixed;
    z-index: 1000;
    background: var(--tti-popover-bg-color);
    border: 1px solid var(--tti-popover-border-color);
    padding: 0.5em;
    border-radius: 4px;
    box-shadow: var(--tti-popover-box-shadow);
    display: none;

    &.show {
        display: block;
    }

    &[data-popper-placement^='top'] .arrow {
        bottom: -5px;
    }
    &[data-popper-placement^='top'] .arrow::before {
        border-top: none;
        border-left: none;
    }
    &[data-popper-placement^='bottom'] .arrow {
        top: -5px;
    }
    &[data-popper-placement^='bottom'] .arrow::before {
        border-bottom: none;
        border-right: none;
    }
    &[data-popper-placement^='left'] .arrow {
        right: -5px;
    }
    &[data-popper-placement^='left'] .arrow::before {
        border-left: none;
        border-bottom: none;
    }
    &[data-popper-placement^='right'] .arrow {
        left: -5px;
    }
    &[data-popper-placement^='right'] .arrow::before {
        border-right: none;
        border-top: none;
    }
}

.arrow {
    display: block;
    position: absolute;
    width: 10px;
    height: 10px;

    &::before {
        content: '';
        position: absolute;
        width: 10px;
        height: 10px;
        background: var(--tti-popover-bg-color);
        border: 1px solid var(--tti-popover-border-color);
        transform: rotate(45deg);
    }
}